//returns min top of all displyed images
function showImageTest(fromIndex, toIndex)
{
  //just to be sure (it may happen if presTime == 0 for an intermediate screen - this is not valid though)
  // hideTargetAndTest();

  console.log('showImages from', fromIndex, ' to ', toIndex);

  if (toIndex === undefined) {
    toIndex = fromIndex - 1;
    fromIndex = 0;
  }

  var n = toIndex - fromIndex + 1;
  var minTop = Number.POSITIVE_INFINITY;
  //display elements
  if(columnForTrial('responseType', window.trialRow) == 'sort'){
    initializeSortableContainer();
    return;
  }
  for (var i = 0; i < n; i++) {
    stimContainers[i + 1 + fromIndex].style.left = window.stimuliPositions[i + 1 + fromIndex].left + 'px';
    stimContainers[i + 1 + fromIndex].style.top = window.stimuliPositions[i + 1 + fromIndex].top + 'px';
    stimContainers[i + 1 + fromIndex].style.display="block";

    //TODO this could be moved up (inline) if performance is bad
    var stimTop = parseInt(stimContainers[i + 1 + fromIndex].style.top);
    if (stimTop < minTop) {
      minTop = stimTop;
    }
  }

  //performance measure
  window.setupScreenStart && console.info('!!! PERFORMANCE setupScreen took', performance.now() - window.setupScreenStart);
  window.screenViewStart = performance.now();

  return minTop;
}